export const bannerType = {
  EXT_LINK: 1,
  OFFER_LINK: 2,
  MERCHANT_LINK: 3,
  SELF_DESCRIPTION: 4,
};

export const dealType = {
  PERCENTAGE: 1,
  FLAT: 2,
};
